import { UserSettingsActions } from '../../userSettings/services/UserSettingsActions';
import { IUserInfo } from '../models/IUserInfo';
import { IUserSettings } from '../models/IUserSettings';
import { Module } from '../Module';
import { ConfirmActionDialog, IConfirmActionDialogInstance } from '../services/ConfirmActionDialog';

export interface IResetStartPageScope extends ng.IScope {
  userPageOverridden(): boolean;
  userSettings: IUserSettings;
  busy: boolean;
  resetStartPage(): void;
  onSuccess(): void;
  serverUser: IUserInfo;
}

Module.instance().directive('tbResetStartPage', [
  '$translate',
  'ConfirmActionDialog',
  ($translate: ng.translate.ITranslateService,
   confirmActionDialog: ConfirmActionDialog) => {
    return {
      restrict: 'E',
      replace: true,
      templateUrl: 'resetStartPage.html',
      scope: {
        userSettings: '=',
        serverUser: '='
      },
      link: (scope: IResetStartPageScope) => {
        scope.resetStartPage = () => {
          confirmActionDialog.open({
            title : $translate.instant('resetStartPageConfirmTitle'),
            bodyText : $translate.instant('resetStartPageConfirmMessage'),
            actionName : $translate.instant('resetStartPageConfirmButton'),
            action : (dialogInstance: IConfirmActionDialogInstance) => {
              const user = scope.serverUser;
              return UserSettingsActions.resetStartPage(user).
                then((result: any) => {
                  // TODO: move this logic into an action or store
                  if (!result || result.errors) {
                    dialogInstance.showErrorMessage($translate.instant('resetStartPageError'));
                  }
                });
            }
          });
        };
        scope.userPageOverridden = () => !!scope.userSettings.startPage;
      }
    };
  }
]);
